import React from 'react';
import PropTypes from 'prop-types';

// Utils
import bemify from 'utils/bemify';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);

const Badge = ({
  className = null,
  text = null,
  theme = null
}) => (
  <span className={`${styles.badge}${theme ? ` ${styles[`badge_${theme}`]}` : ''}${className ? ` ${className}` : ''}`}>
    {text}
  </span>
);

Badge.propTypes = {
  className: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.oneOf(['success', 'error'])
};

export default Badge;
